module.exports = __webpack_public_path__ + "img/dots.2b8397fc.svg";